import { createGlobalStyle } from 'styled-components';

import {
	fontFamily,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	themeFontFamily,
} from '../../utils/typography';

const GlobalStyle = createGlobalStyle`
  html, body {
    font-size: 16px;
    padding: 0;
  }

  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: border-box;
    margin: 0;
  }

  body {
    ${({ theme }) => {
			const themeWithFonts = theme as { fonts?: { fontFamily?: string } };
			return themeWithFonts?.fonts?.fontFamily
				? themeFontFamily(themeWithFonts.fonts.fontFamily)
				: fontFamily;
		}};
    ${fontWeight(FontWeights.Regular)};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1 {
    ${fontSize(FontSizes['4xl'])};
  }

  h2 {
    ${fontSize(FontSizes['3xl'])};
  }

  h3 {
    ${fontSize(FontSizes['2xl'])};
  }

  h4 {
    ${fontSize(FontSizes.xl)};
  }

  h5 {
    ${fontSize(FontSizes.lg)};
  }

  h6 {
    ${fontSize(FontSizes.sm)};
  }

  p {
    ${fontSize(FontSizes.base)};
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
    padding: 0;
  }

  a {
    color: inherit;
    cursor: pointer;
  }

  select, button { 
    ${({ theme }) => {
			const themeWithFonts = theme as { fonts?: { fontFamily?: string } };
			return themeWithFonts?.fonts?.fontFamily
				? themeFontFamily(themeWithFonts.fonts.fontFamily)
				: fontFamily;
		}}; 
    ${fontSize(FontSizes.base)};
  }
`;

export default GlobalStyle;
